import picturefill from 'picturefill';

picturefill();

export default picturefill;
